/* eslint-disable import/no-extraneous-dependencies */
import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';
import UtilService from '../../services/UtilService';

const browserHistory = createBrowserHistory({ basename: '' });
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: UtilService.fetchInsightKey(),
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
        }
    }
});

const getMethodNameFromBody = (body) => {
    let ret = '';
    if (!body) {
        return ret;
    }
    const regex = /"method":"[a-zA-Z0-9_-]*"/;
    const result = body.match(regex);
    if (result && result.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        const retName = result[0];
        // sample string: "method":"getClaimSummaries_WSIB"
        ret = retName.substring(10, retName.length - 1);
    }
    return ret;
};

const getMaskedBodyContentByMethod = (body, method) => {
    if (method === 'updateDirectDepositBankInfo') {
        // sample string "bankAccountNumber":"12345678",
        const regex = /"bankAccountNumber":"[a-zA-Z0-9_-]*"/;
        const result = regex.exec(body);
        if (result) {
            const startIndex = result.index;
            const {length} = result['0'];
            const strBefore = body.substring(0, startIndex + '"bankAccountNumber":"'.length);
            const strAfter = body.substring(startIndex + length - 1);
            const replace = '*'.repeat(length - 1 - '"bankAccountNumber":"'.length);
            return strBefore + replace + strAfter;
        }
        return body;
    }
    return body;
};

const getLogIDForSession = () => {
    const logid = appInsights.context.getSessionId();
    /*  const logSessionID = sessionStorage.getItem('wsiblogid');
    if (logSessionID) {
        return logSessionID;
    }
    const now = new Date();
    const isoString = now.toISOString();
    const id = isoString.replace(/[-:\\.TZ]/g, '');
    const logid = `osbc-${id}`;
    sessionStorage.setItem('wsiblogid', logid); */
    return logid;
};

// by default when Error object is used for AI log, it only logs message property, so 
// need to extact other properties for log purpose
function copyPropertiesFromErrToProps(errObj, props) {
    if (Object.prototype.hasOwnProperty.call(errObj, 'status')) {
        // eslint-disable-next-line no-param-reassign
        props.status = errObj.status;
    }
    if (Object.prototype.hasOwnProperty.call(errObj, 'baseError')) {
        // eslint-disable-next-line no-param-reassign
        props.baseError = errObj.baseError;
    }
    if (Object.prototype.hasOwnProperty.call(errObj, 'message')) {
        // eslint-disable-next-line no-param-reassign
        props.message = errObj.message;
    }
    if (Object.prototype.hasOwnProperty.call(errObj, 'stack')) {
        // eslint-disable-next-line no-param-reassign
        props.stack = errObj.stack;
    }
    if (Object.prototype.hasOwnProperty.call(errObj, 'name')) {
        // eslint-disable-next-line no-param-reassign
        props.name = errObj.name;
    }
}


// track exception may have three calling parameter format
// trackException(err), this format is for backward compatible, err is Error type
// trackException(err, propCollection), err is string or Error type, propCollection contains additional properties, 
//         this is for the case when app logic logs throws error
// trakcException(strErr, propCollection, errorObject), this is used for catch handler with additional properties

const trackException = (err, props, errObj) => {

    const id = getLogIDForSession();
    if (!props) {
        // eslint-disable-next-line no-param-reassign
        props = {};
    }
    // eslint-disable-next-line no-param-reassign
    props.logid = id;

    const errType = typeof err;
    if (errType === 'string') {
        if (errObj) {
            // Logging the error message from Service Call to APM Tool
            copyPropertiesFromErrToProps(errObj, props);
        }
    } else {
        copyPropertiesFromErrToProps(err, props);
    }

    appInsights.trackException({
        exception: err,
        properties: props
    });
};

const trackEvent = (name, props) => {
    const id = getLogIDForSession();
    // eslint-disable-next-line no-param-reassign
    props.logid = id;
    appInsights.trackEvent({
        name: name,
        properties: props
    });
};

const trackTrace = (message, props) => {
    const id = getLogIDForSession();
    // eslint-disable-next-line no-param-reassign
    props.logid = id;
    appInsights.trackTrace({
        message: message,
        properties: props,
        severityLevel: SeverityLevel.Information
    }, {});
};

appInsights.loadAppInsights();
export {
    reactPlugin,
    appInsights,
    trackException,
    withAITracking,
    trackEvent,
    trackTrace,
    getMethodNameFromBody,
    getMaskedBodyContentByMethod
};

